import {useEffect, useMemo, useRef} from "react";

import {isEqual} from "@pg-mono/nodash";

import {useGetPropertiesCountQuery} from "../../property/api/get_properties_count";
import {propertyListConstraints} from "../../property/constants/property_list_constraints";
import {gtmEventOfferListSearch} from "../../tracking/google_tag_manager/gtm_event_ui";
import {ILatestQuery} from "../../utils/latest_query";
import {IMapOfferListPayload, useGetFullMapOfferListQuery} from "../api/get_map_offer_list";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {IUseMapOfferListQueryResult} from "./use_map_offer_list_query";

interface IProps {
    mapOfferListQuery?: IUseMapOfferListQueryResult;
}

export interface IUseMapOfferListDataResult {
    offers: IOfferListMapOffer[] | null;
    count: number;
    propertiesCount: number | null;
    isLoading: boolean;
    isError: boolean;
    error: unknown;
    latestQuery: ILatestQuery;
}

export const useMapOfferListData = (props: IProps): IUseMapOfferListDataResult => {
    const prevLatestQueryRef = useRef<ILatestQuery>({});

    const {query: fullQuery, baseQuery, isLoading: queryLoading, error: queryError} = props.mapOfferListQuery || {};

    const shouldSkip = useMemo(() => {
        if (!fullQuery) {
            return true;
        }

        return isEqual(prevLatestQueryRef.current, fullQuery);
    }, [fullQuery]);

    const apiPayload: IMapOfferListPayload | null = useMemo(() => {
        if (!fullQuery) return null;
        return {
            ...fullQuery,
            page: 1 // Always start with page 1 for map view
        } as IMapOfferListPayload;
    }, [fullQuery]);

    const {
        data: mapOfferListData,
        isLoading: isMapOfferListLoading,
        isUninitialized: isMapOfferListUninitialized,
        isError: isMapOfferListError,
        error: mapOfferListError
    } = useGetFullMapOfferListQuery(apiPayload!, {
        skip: shouldSkip || !apiPayload
    });

    const {data: propertiesCount, isLoading: isPropertiesCountLoading} = useGetPropertiesCountQuery(
        {
            ...(baseQuery || {}),
            ...propertyListConstraints
        },
        {
            skip: shouldSkip || !baseQuery
        }
    );

    useEffect(() => {
        if (!shouldSkip && fullQuery) {
            const prevQuery = prevLatestQueryRef.current;

            if (!(isEqual(prevQuery.rooms_0, fullQuery.rooms_0) && isEqual(prevQuery.rooms_1, fullQuery.rooms_1))) {
                gtmEventOfferListSearch("pokoje");
            }
            if (!(isEqual(prevQuery.area_0, fullQuery.area_0) && isEqual(prevQuery.area_1, fullQuery.area_1))) {
                gtmEventOfferListSearch("powierzchnia");
            }
            if (!(isEqual(prevQuery.price_0, fullQuery.price_0) && isEqual(prevQuery.price_1, fullQuery.price_1))) {
                gtmEventOfferListSearch("cena");
            }
            if (!isEqual(prevQuery.floor_choices, fullQuery.floor_choices)) {
                gtmEventOfferListSearch("piętro");
            }
            if (!isEqual(prevQuery.construction_end_date, fullQuery.construction_end_date)) {
                gtmEventOfferListSearch("termin oddania");
            }

            prevLatestQueryRef.current = fullQuery;
        }
    }, [fullQuery, shouldSkip]);

    return {
        offers: mapOfferListData?.offers || null,
        count: mapOfferListData?.count || 0,
        propertiesCount: propertiesCount || null,
        isLoading: isMapOfferListUninitialized || isMapOfferListLoading || isPropertiesCountLoading || queryLoading || false,
        isError: isMapOfferListError,
        error: mapOfferListError || queryError || false,
        latestQuery: fullQuery || {}
    };
};
import {useEffect, useMemo, useRef} from "react";

import {isEqual} from "@pg-mono/nodash";

import {useGetPropertiesCountQuery} from "../../property/api/get_properties_count";
import {propertyListConstraints} from "../../property/constants/property_list_constraints";
import {gtmEventOfferListSearch} from "../../tracking/google_tag_manager/gtm_event_ui";
import {ILatestQuery} from "../../utils/latest_query";
import {IMapOfferListPayload, useGetFullMapOfferListQuery} from "../api/get_map_offer_list";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {IUseMapOfferListQueryResult} from "./use_map_offer_list_query";

interface IProps {
    mapOfferListQuery?: IUseMapOfferListQueryResult;
}

export interface IUseMapOfferListDataResult {
    offers: IOfferListMapOffer[] | null;
    count: number;
    propertiesCount: number | null;
    isLoading: boolean;
    isError: boolean;
    error: unknown;
    latestQuery: ILatestQuery;
}

export const useMapOfferListData = (props: IProps): IUseMapOfferListDataResult => {
    const prevLatestQueryRef = useRef<ILatestQuery>({});

    const {query: fullQuery, baseQuery, isLoading: queryLoading, error: queryError} = props.mapOfferListQuery || {};

    const shouldSkip = useMemo(() => {
        if (!fullQuery) {
            return true;
        }

        return isEqual(prevLatestQueryRef.current, fullQuery);
    }, [fullQuery]);

    const apiPayload: IMapOfferListPayload | null = useMemo(() => {
        if (!fullQuery) return null;
        return {
            ...fullQuery,
            page: 1 // Always start with page 1 for map view
        } as IMapOfferListPayload;
    }, [fullQuery]);

    const {
        data: mapOfferListData,
        isLoading: isMapOfferListLoading,
        isUninitialized: isMapOfferListUninitialized,
        isError: isMapOfferListError,
        error: mapOfferListError
    } = useGetFullMapOfferListQuery(apiPayload!, {
        skip: shouldSkip || !apiPayload
    });

    const {data: propertiesCount, isLoading: isPropertiesCountLoading} = useGetPropertiesCountQuery(
        {
            ...(baseQuery || {}),
            ...propertyListConstraints
        },
        {
            skip: shouldSkip || !baseQuery
        }
    );

    useEffect(() => {
        if (!shouldSkip && fullQuery) {
            const prevQuery = prevLatestQueryRef.current;

            if (!(isEqual(prevQuery.rooms_0, fullQuery.rooms_0) && isEqual(prevQuery.rooms_1, fullQuery.rooms_1))) {
                gtmEventOfferListSearch("pokoje");
            }
            if (!(isEqual(prevQuery.area_0, fullQuery.area_0) && isEqual(prevQuery.area_1, fullQuery.area_1))) {
                gtmEventOfferListSearch("powierzchnia");
            }
            if (!(isEqual(prevQuery.price_0, fullQuery.price_0) && isEqual(prevQuery.price_1, fullQuery.price_1))) {
                gtmEventOfferListSearch("cena");
            }
            if (!isEqual(prevQuery.floor_choices, fullQuery.floor_choices)) {
                gtmEventOfferListSearch("piętro");
            }
            if (!isEqual(prevQuery.construction_end_date, fullQuery.construction_end_date)) {
                gtmEventOfferListSearch("termin oddania");
            }

            prevLatestQueryRef.current = fullQuery;
        }
    }, [fullQuery, shouldSkip]);

    return {
        offers: mapOfferListData?.offers || null,
        count: mapOfferListData?.count || 0,
        propertiesCount: propertiesCount || null,
        isLoading: isMapOfferListUninitialized || isMapOfferListLoading || isPropertiesCountLoading || queryLoading || false,
        isError: isMapOfferListError,
        error: mapOfferListError || queryError || false,
        latestQuery: fullQuery || {}
    };
};
